var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { ref: "slaWrapper" }, [
      _c(
        "div",
        { staticStyle: { "text-align": "justify", "padding-right": "10px" } },
        [
          _c(
            "div",
            {
              staticStyle: { "text-align": "center", "margin-bottom": "24px" },
            },
            [
              _c("b", [_vm._v("TRIPARTITE SERVICE LEVEL AGREEMENT")]),
              _c("br"),
              _c("span", [
                _vm._v(
                  " GRUPA, " +
                    _vm._s(_vm.teamName) +
                    " AND " +
                    _vm._s(_vm.clientName) +
                    " "
                ),
              ]),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "spandiv",
              staticStyle: { "margin-bottom": "24px" },
            },
            [
              _vm._v(
                "\n        This Service Level Agreement (“this Agreement” or “SLA”) is a legally\n        binding document by PLATOHUB INC. dba GRUPA., a corporation registered\n        under the laws of the State of Delaware and with a registered office\n        address at 4320 Stevens Creek Boulevard, Suite 175, San Jose, CA;\n        95129 (trading under the brand name “Grupa.io” or “Grupa”) is made\n        Between.\n      "
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "spandiv",
              staticStyle: { "margin-bottom": "24px" },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.teamName) +
                  ' ("the Consultant", "Co-creator" or "Expert"),\n        and ' +
                  _vm._s(_vm.clientName) +
                  ", a corporation registered under the laws of\n        Delaware with registered office address at {Startup.Address} (“the\n        Customer”).\n      "
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "spandiv",
              staticStyle: { "margin-bottom": "24px" },
            },
            [
              _vm._v(
                "\n        By registering and subscribing to the Grupa platform, the Customer and\n        Consultant both agree to be bound by the terms of this Agreement under\n        the laws of the United States of America (“Elected Country”).\n      "
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "spandiv",
              staticStyle: { "margin-bottom": "24px" },
            },
            [
              _vm._v(
                '\n        In this Agreement, "Expert(s)" means the applicable Consultant and any\n        of its applicable Affiliates, and “You” means the Customer (if\n        registering for or using a Service as an individual), or the business\n        employing or represented by the registrant (if registering for or\n        using the platform as a business) and any of its affiliates. You and\n        Consultant mean the "Parties".\n      '
              ),
            ]
          ),
          _vm._m(0),
          _c(
            "div",
            {
              staticClass: "spandiv",
              staticStyle: { "margin-bottom": "12px" },
            },
            [
              _vm._v(
                "\n        A. The Consultant is knowledgeable and skilled in the relevant\n        software development.\n      "
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "spandiv",
              staticStyle: { "margin-bottom": "12px" },
            },
            [
              _vm._v(
                "\n        B. During this engagement, both Parties will encounter, obtain or\n        receive information that is considered confidential information (as\n        hereinafter defined).\n      "
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "spandiv",
              staticStyle: { "margin-bottom": "12px" },
            },
            [
              _vm._v(
                "\n        C. The Customer has conceptualized a business idea, which is described\n        in detail below;\n      "
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "spandiv",
              staticStyle: { "margin-bottom": "28px" },
            },
            [
              _vm._v(
                "\n        D. The Customer now engages the Consultant to build and advice on\n        certain innovative solutions in the Consultant’s capacity as a\n        technology expert service provider.\n      "
              ),
            ]
          ),
          _vm._m(1),
          _vm._m(2),
          _vm._m(3),
          _vm._m(4),
          _vm._m(5),
          _vm._m(6),
          _c("div", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v("1. DESCRIPTION OF SERVICES"),
          ]),
          _c("div", { staticStyle: { "margin-bottom": "18px" } }, [
            _vm._v(
              "\n        The Consultant will provide software engineering services for the\n        development and engineering of a web and mobile software platform\n        (“the Product”) for the Customer by providing product engineering and\n        leadership as requested by the Customer.\n      "
            ),
          ]),
          _vm._m(7),
          _c("br"),
          _c("div", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v("\n        2. COMPENSATION (PER EXPERT):\n        "),
            _c("span", { staticStyle: { "text-transform": "uppercase" } }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.grupaCompensation(_vm.project.compensation_id))
              ),
            ]),
          ]),
          _c(
            "table",
            {
              staticStyle: {
                width: "100%",
                border: "1px solid black",
                "margin-top": "10px",
                "margin-bottom": "20px",
              },
            },
            [
              _vm._m(8),
              _c(
                "tr",
                { staticStyle: { border: "1px solid #ccc", padding: "10px" } },
                [
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        width: "20%",
                        border: "1px solid #ccc",
                      },
                    },
                    [_vm._v("\n            Cash\n          ")]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        width: "20%",
                        border: "1px solid #ccc",
                      },
                    },
                    [
                      _vm._v(
                        "\n            $" +
                          _vm._s(_vm.project.price.toLocaleString()) +
                          "\n          "
                      ),
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        border: "1px solid #ccc",
                      },
                    },
                    [_vm._v("\n            In USD per month\n          ")]
                  ),
                ]
              ),
              _c(
                "tr",
                { staticStyle: { border: "1px solid #ccc", padding: "10px" } },
                [
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        width: "20%",
                        border: "1px solid #ccc",
                      },
                    },
                    [_vm._v("\n            Equity\n          ")]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        width: "20%",
                        border: "1px solid #ccc",
                      },
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(_vm.equity) + "%\n          "
                      ),
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        border: "1px solid #ccc",
                      },
                    },
                    [
                      _vm._v(
                        "\n            In % over the term of the contract Equity Vesting Schedule: Each\n            Equity compensation granted to the Consultant shall vest equally\n            every month over an 18-month period with an initial 3-month cliff\n            period, subject to the performance and achievement of targets set\n            by the Customer in its product roadmap.\n          "
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
          _c("br"),
          _c("div", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v(
              "\n        3. CONSULTANT: COMPOSITION AND ENGAGEMENT DETAILS\n      "
            ),
          ]),
          _c(
            "table",
            {
              staticStyle: {
                width: "100%",
                border: "1px solid black",
                "margin-top": "10px",
                "margin-bottom": "20px",
              },
            },
            [
              _vm._m(9),
              _vm._m(10),
              _vm._l(_vm.teamDetails.members, function (engr, index) {
                return _c(
                  "tr",
                  {
                    staticStyle: { border: "1px solid #ccc", padding: "10px" },
                  },
                  [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          padding: "10px",
                          "background-color": "#fff",
                          width: "20%",
                          border: "1px solid #ccc",
                        },
                      },
                      [
                        _vm._v(
                          "\n            " + _vm._s(engr.name) + "\n          "
                        ),
                      ]
                    ),
                    _c(
                      "th",
                      {
                        staticStyle: {
                          padding: "10px",
                          "background-color": "#fff",
                          width: "20%",
                          border: "1px solid #ccc",
                        },
                      },
                      [
                        _vm._v(
                          "\n            " + _vm._s(engr.name) + "\n          "
                        ),
                      ]
                    ),
                    _c(
                      "th",
                      {
                        staticStyle: {
                          padding: "10px",
                          width: "20%",
                          "background-color": "#fff",
                          border: "1px solid #ccc",
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.project.desired_hours) +
                            "\n          "
                        ),
                      ]
                    ),
                    _c(
                      "th",
                      {
                        staticStyle: {
                          padding: "10px",
                          "background-color": "#fff",
                          width: "20%",
                          border: "1px solid #ccc",
                        },
                      },
                      [
                        _vm._v(
                          "\n            $" +
                            _vm._s(
                              _vm.project.price
                                ? _vm.project.price.toLocaleString()
                                : ""
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                    _c(
                      "th",
                      {
                        staticStyle: {
                          padding: "10px",
                          width: "20%",
                          "background-color": "#fff",
                          border: "1px solid #ccc",
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.equity) +
                            "%\n          "
                        ),
                      ]
                    ),
                    _c(
                      "th",
                      {
                        staticStyle: {
                          padding: "10px",
                          "background-color": "#fff",
                          border: "1px solid #ccc",
                        },
                      },
                      [
                        _vm._v(
                          "\n           $" +
                            _vm._s(_vm.project.price.toLocaleString()) +
                            "\n          "
                        ),
                      ]
                    ),
                  ]
                )
              }),
            ],
            2
          ),
          _c(
            "table",
            {
              staticStyle: {
                width: "100%",
                border: "0px solid black",
                "margin-top": "20px",
                "margin-bottom": "20px",
              },
            },
            [
              _c("tr", [
                _c("td", {
                  staticStyle: {
                    padding: "10px",
                    "background-color": "#fff",
                    width: "20%",
                    border: "0px solid #ccc",
                  },
                }),
                _c("td", {
                  staticStyle: {
                    padding: "10px",
                    "background-color": "#fff",
                    width: "20%",
                    border: "0px solid #ccc",
                  },
                }),
                _c("td", {
                  staticStyle: {
                    padding: "10px",
                    width: "20%",
                    "background-color": "#fff",
                    border: "0px solid #ccc",
                  },
                }),
                _c(
                  "td",
                  {
                    staticStyle: {
                      padding: "10px",
                      "background-color": "#fff",
                      width: "20%",
                      border: "0px solid #ccc",
                      "padding-left": "20px",
                      "text-align": "right",
                    },
                  },
                  [_vm._v("\n            Subtotal\n          ")]
                ),
                _c("td", {
                  staticStyle: {
                    padding: "10px",
                    width: "20%",
                    "background-color": "#fff",
                    border: "0px solid #ccc",
                  },
                }),
                _c(
                  "th",
                  {
                    staticStyle: {
                      padding: "10px",
                      "background-color": "#fff",
                    },
                  },
                  [
                    _vm._v(
                      "\n            $" +
                        _vm._s(_vm.teamSubTotal.toLocaleString()) +
                        ".00\n          "
                    ),
                  ]
                ),
              ]),
              _vm._m(11),
              _vm._m(12),
              _c("tr", [
                _c("td", {
                  staticStyle: {
                    padding: "10px",
                    "background-color": "#fff",
                    width: "20%",
                  },
                }),
                _c("td", { staticStyle: { padding: "10px", width: "20%" } }),
                _c("td", {
                  staticStyle: {
                    padding: "10px",
                    width: "20%",
                    "background-color": "#fff",
                  },
                }),
                _c(
                  "th",
                  {
                    staticStyle: {
                      padding: "10px",
                      width: "20%",
                      "padding-left": "20px",
                      "text-align": "right",
                    },
                  },
                  [_vm._v("\n            Total\n          ")]
                ),
                _c("td", { staticStyle: { padding: "10px", width: "20%" } }),
                _c(
                  "th",
                  {
                    staticStyle: {
                      padding: "10px",
                      "background-color": "#fff",
                    },
                  },
                  [
                    _vm._v(
                      "\n            $" +
                        _vm._s(
                          (parseInt(_vm.teamSubTotal) + 562.5).toLocaleString()
                        ) +
                        ".00\n          "
                    ),
                  ]
                ),
              ]),
            ]
          ),
          _c("div", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v("4. SERVICE DURATION"),
          ]),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "8px", "margin-left": "20px" } },
            [
              _vm._v(
                "\n        1. The Consultant shall provide 18 months of engineering service with\n        initial 3 months as a trial period with a cliff as outlined below and\n        in accordance with the specifications attached hereto as Statement of\n        Work (the “SOW”) agreed between the Parties.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "18px", "margin-left": "20px" } },
            [
              _vm._v(
                "\n        2. The project execution will commence immediately upon execution of\n        this SLA and payment of initial Consideration as stated below\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "font-weight": "bold", "margin-top": "20px" } },
            [_vm._v("5. PAYMENT TERMS")]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "8px", "margin-left": "20px" } },
            [
              _vm._v(
                "\n        5.1 The Consultant and the Customer understand that Grupa shall be\n        entitled to " +
                  _vm._s(_vm.project.percentage_cut) +
                  "% of any Cash and or Equity compensation given to the\n        Consultant by the Customer.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "20px", "margin-left": "20px" } },
            [
              _vm._v(
                "\n        5.2 The Customer shall pay Grupa.io a total monthly rate of USD " +
                  _vm._s(_vm.project.price.toLocaleString()) +
                  "\n        (VAT exclusive) and " +
                  _vm._s(_vm.equity) +
                  "% equity vested over 18 months, subject to the\n        vesting schedule in clause 3 above and the compensation breakdown\n        below in this clause 5.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "20px", "margin-left": "20px" } },
            [
              _vm._v(
                "\n        5.3 The Customer shall ensure prompt payment of the initial\n        Consideration within 5 (five) working days of execution of this SLA,\n        through the Grupa.io platform.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "20px", "margin-left": "20px" } },
            [
              _vm._v(
                "\n        5.4 Subsequently, the payment due to the Consultant shall be released\n        upon completion of weekly sprint and on the Customer’s approval of\n        such sprint completed by the Consultant.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "20px", "margin-left": "20px" } },
            [
              _vm._v(
                "\n        5.5 The payment shall be remitted to the Experts within 5 working days\n        after confirmation of payment by the Customer, taking into\n        consideration any payment processing periods.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "20px", "margin-left": "20px" } },
            [
              _vm._v(
                "\n        5.6 Disbursements and payouts shall be made bi-weekly based on the\n        weekly sprint breakdown of payment outlined below.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "20px", "margin-left": "20px" } },
            [
              _vm._v(
                "\n        5.7 The table below shows the payment schedule per iteration for the\n        Consultant(s):\n      "
              ),
            ]
          ),
          _c(
            "table",
            {
              staticStyle: {
                width: "100%",
                border: "1px solid black",
                "margin-top": "30px",
                "margin-bottom": "20px",
              },
            },
            [
              _vm._m(13),
              _c(
                "tr",
                { staticStyle: { border: "1px solid #ccc", padding: "10px" } },
                [
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        border: "1px solid #ccc",
                      },
                    },
                    [_vm._v("\n            Month 1...18\n          ")]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        border: "1px solid #ccc",
                      },
                    },
                    [_vm._v("\n            SPRINT 1\n          ")]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        border: "1px solid #ccc",
                      },
                    },
                    [
                      _vm._v(
                        "\n            $" +
                          _vm._s(_vm.project.price.toLocaleString()) +
                          "\n          "
                      ),
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        border: "1px solid #ccc",
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.project.percentage_cut) +
                          "% \n          "
                      ),
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        border: "1px solid #ccc",
                      },
                    },
                    [
                      _vm._v(
                        "\n            $" +
                          _vm._s((_vm.project.price / 4).toLocaleString()) +
                          "\n          "
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "tr",
                { staticStyle: { border: "1px solid #ccc", padding: "10px" } },
                [
                  _c("td", {
                    staticStyle: {
                      padding: "10px",
                      "background-color": "#fff",
                      border: "1px solid #ccc",
                    },
                  }),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        border: "1px solid #ccc",
                      },
                    },
                    [_vm._v("\n            SPRINT 2\n          ")]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        border: "1px solid #ccc",
                      },
                    },
                    [
                      _vm._v(
                        "\n            $" +
                          _vm._s(_vm.project.price.toLocaleString()) +
                          "\n          "
                      ),
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        border: "1px solid #ccc",
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.project.percentage_cut) +
                          "% \n          "
                      ),
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        border: "1px solid #ccc",
                      },
                    },
                    [
                      _vm._v(
                        "\n            $" +
                          _vm._s((_vm.project.price / 4).toLocaleString()) +
                          "\n          "
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "tr",
                { staticStyle: { border: "1px solid #ccc", padding: "10px" } },
                [
                  _c("td", {
                    staticStyle: {
                      padding: "10px",
                      "background-color": "#fff",
                      border: "1px solid #ccc",
                    },
                  }),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        border: "1px solid #ccc",
                      },
                    },
                    [_vm._v("\n            SPRINT 3\n          ")]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        border: "1px solid #ccc",
                      },
                    },
                    [
                      _vm._v(
                        "\n             $" +
                          _vm._s(_vm.project.price.toLocaleString()) +
                          "\n          "
                      ),
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        border: "1px solid #ccc",
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.project.percentage_cut) +
                          "% \n          "
                      ),
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        border: "1px solid #ccc",
                      },
                    },
                    [
                      _vm._v(
                        "\n             $" +
                          _vm._s((_vm.project.price / 4).toLocaleString()) +
                          "\n          "
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "tr",
                { staticStyle: { border: "1px solid #ccc", padding: "10px" } },
                [
                  _c("td", {
                    staticStyle: {
                      padding: "10px",
                      "background-color": "#fff",
                      border: "1px solid #ccc",
                    },
                  }),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        border: "1px solid #ccc",
                      },
                    },
                    [_vm._v("\n            SPRINT 4\n          ")]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        border: "1px solid #ccc",
                      },
                    },
                    [
                      _vm._v(
                        "\n             $" +
                          _vm._s(_vm.project.price.toLocaleString()) +
                          "\n          "
                      ),
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        border: "1px solid #ccc",
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.project.percentage_cut) +
                          "% \n          "
                      ),
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        border: "1px solid #ccc",
                      },
                    },
                    [
                      _vm._v(
                        "\n            $" +
                          _vm._s((_vm.project.price / 4).toLocaleString()) +
                          "\n          "
                      ),
                    ]
                  ),
                ]
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "20px", "margin-left": "20px" } },
            [
              _vm._v(
                "\n        5.8 The Customer shall ensure prompt provision of dependencies as\n        requested before the agreed due date based on the Product roadmap in\n        the Appendix below. Any delay in the provision of resources/items or\n        dependencies may lead to missed sprint due dates and will incur\n        charges for the extension of the sprint timeline based on the\n        calculations in this clause.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "font-weight": "bold", "margin-top": "30px" } },
            [_vm._v("\n        6. OBLIGATIONS OF THE PARTIES\n      ")]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "8px", "margin-left": "20px" } },
            [_vm._v("\n        6.1 OBLIGATIONS OF THE CONSULTANT\n      ")]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px", "margin-left": "40px" } },
            [
              _vm._v(
                "\n        6.1.1 Develop, create and or advice on products or software in line\n        with the contents of the Statement of Work and provide weekly updates\n        to the Customer.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px", "margin-left": "40px" } },
            [
              _vm._v(
                "\n        6.1.2 Ensure effective communication to the Customer regarding the\n        Product and any queries or questions that may arise.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px", "margin-left": "40px" } },
            [
              _vm._v(
                "\n        6.1.3 Be required to respond timely to any questions, issues, queries,\n        and or concerns from the Customer regarding documentation and\n        requirements in accordance with Clause 7 (Escalation Process) below.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px", "margin-left": "40px" } },
            [
              _vm._v(
                "\n        6.1.5 Complete the development of the Software according to the\n        milestones described on the form attached hereto as Exhibit A.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px", "margin-left": "40px" } },
            [
              _vm._v(
                "\n        6.1.6 The Consultant affirms as follows:\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px", "margin-left": "60px" } },
            [
              _vm._v(
                "\n        a. that undertaking these Services or any service on the Grupa\n        platform have no conflict with any of their existing jobs,\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px", "margin-left": "60px" } },
            [
              _vm._v(
                "\n        b. that, with the exclusion of open sourced, paid, subscription tools\n        or equipment, they will not use any resources, equipment or licenses\n        owned by any third party to carry out this Service, and\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px", "margin-left": "60px" } },
            [
              _vm._v(
                "\n        c. that taking up the Service will not cause them to reveal any\n        Intellectual Property belonging to any third party or breach any\n        employment or service agreement to which they are a party to or\n        currently bound to.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "8px", "margin-left": "20px" } },
            [_vm._v("\n        6.2 OBLIGATIONS OF THE CUSTOMER\n      ")]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px", "margin-left": "40px" } },
            [
              _vm._v(
                "\n        6.2.1 immediately upon execution of this Agreement, provide all\n        relevant information including but not limited to the Statement of\n        Work and other requirements.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px", "margin-left": "40px" } },
            [
              _vm._v(
                "\n        6.2.2 Within 24 hours of communication from the team required to\n        respond to questions, issues, queries, and or concerns regarding\n        documentation and requirements.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px", "margin-left": "40px" } },
            [
              _vm._v(
                "\n        6.2.3 Promptly and upon completion of the SOW, pay the full and final\n        consideration based on the Grupa service plan selected.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "font-weight": "bold", "margin-top": "30px" } },
            [_vm._v("\n        6. OBLIGATIONS OF THE PARTIES\n      ")]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px", "margin-left": "20px" } },
            [
              _vm._v(
                "\n        Each Party hereby acknowledges that this Agreement will require\n        significant interaction between the Parties on a regular basis\n        throughout the Term of the Agreement. Each Party further agrees that\n        each Party shall designate an “Escalation Contact” creating a single\n        line of communication for the purpose of resolving specific problems\n        or issues. Each Party will notify the other Party in a timely manner\n        of the name and contact information of their Escalation Contact. In\n        order to facilitate an efficient and effective process to resolve\n        matters that impact either Party’s operation under this Agreement, the\n        Parties hereby institute the Escalation Process described herein. The\n        Escalation Contact from the Consultant will notify the Escalation\n        Contact from the Customer when any feedback concerning the\n        documentation and requirements in relation to the critical path of the\n        project has been initially requested and has not been responded to\n        within 24 hours of the request. Upon notification from the Escalation\n        Contact from Consultant to the Escalation Contact from the Customer,\n        the Customer shall be required to respond within twenty-four (24)\n        hours of the request.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px", "margin-left": "20px" } },
            [
              _vm._v(
                "\n        Where no response is received by the contact escalating 24 hours after\n        escalation, such contact shall immediately inform Grupa to enable\n        Grupa take the right actions.\n      "
              ),
            ]
          ),
          _c("div", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v("8. PRODUCT INTELLECTUAL PROPERTY"),
          ]),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "18px", "margin-left": "20px" } },
            [
              _vm._v(
                "\n        Any copyrightable works, ideas, discoveries, inventions, patents,\n        products, or other information (collectively the “Work Product”)\n        developed in whole or in part by Consultant in connection with this\n        Agreement shall be solely and irrevocably the exclusive property of\n        the Customer, save where the Customer in written format permits or\n        grants ownership to Consultant for use. The Consultant irrevocably\n        assigns all rights in such Work Product to the Customer as further\n        described in Appendix B below.\n      "
              ),
            ]
          ),
          _c("div", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v(
              "\n        9. CHANGE IN STATEMENT OF WORK AND/OR SCOPE OF WORK\n      "
            ),
          ]),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "18px", "margin-left": "20px" } },
            [
              _vm._v(
                "\n        The Customer may request change(s) to the Statement of Work attached\n        to this agreement after this Agreement has been executed. In the event\n        that a change is proposed by the Customer, the Customer shall make\n        such a request on the Grupa.io platform detailing the changes to be\n        made and follow the process as stated on the Grupa.io platform. The\n        Customer understands that there shall be additional fees and timing\n        required for the changes to be effected, subject to the mutual\n        agreement of both parties. The Customer shall accept such additional\n        fees and timing to ensure completion and delivery of the Product.\n      "
              ),
            ]
          ),
          _c("div", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v("10. CONFIDENTIALITY"),
          ]),
          _vm._m(14),
          _vm._m(15),
          _c("div", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v("11. WARRANTY"),
          ]),
          _c(
            "div",
            { staticStyle: { "margin-left": "22px", "margin-bottom": "18px" } },
            [
              _vm._v(
                "\n        11.1 The Consultant shall provide its services and meet its\n        obligations under this Agreement in a timely and workmanlike manner,\n        using knowledge and recommendations for performing the services which\n        meet generally acceptable standards and will provide a standard of\n        care equal to, or superior to, care used by service providers similar\n        to any professional Customer on similar projects.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-left": "22px", "margin-bottom": "18px" } },
            [
              _vm._v(
                "\n        11.2 The Consultant warrants that the Services provided by the\n        Consultant shall not violate any intellectual property of any other\n        Customer or party.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "font-weight": "bold", "margin-top": "20px" } },
            [_vm._v("12. REFUNDS")]
          ),
          _c(
            "div",
            { staticStyle: { "margin-left": "22px", "margin-bottom": "18px" } },
            [
              _vm._v(
                "\n        12.1 Where the Customer is dissatisfied with the design-thinking or\n        product roadmapping session held with the Consultant, it shall be\n        entitled to a refund of some or all of the Reservation fees paid to\n        the Company for the Services. This clause shall be effective\n        immediately upon engagement of the Consultant on the Grupa.io platform\n        and payment of Reservation fees.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-left": "22px", "margin-bottom": "18px" } },
            [
              _vm._v(
                "\n        12.2 Upon commencement of Services requested by the Customer, a\n        non-repayment clause shall be effective immediately upon payment of\n        agreed Consideration and the commencement of work by the Consultant.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "font-weight": "bold", "margin-top": "40px" } },
            [_vm._v("13. TERMINATION")]
          ),
          _c(
            "div",
            { staticStyle: { "margin-left": "22px", "margin-bottom": "18px" } },
            [
              _vm._v(
                "\n        13.1 The Agreement will commence immediately upon execution of this\n        Agreement by the last signee and shall terminate upon completion,\n        fulfillment, and delivery by the Consultant of the Services described\n        here.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-left": "22px", "margin-bottom": "18px" } },
            [
              _vm._v(
                "\n        13.2 Any Party may terminate this Agreement in the event of an\n        occurrence of a default or at will, upon the non-defaulting Party\n        giving a 4-week notice period.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-left": "22px", "margin-bottom": "8px" } },
            [_vm._v("\n        13.3 An event of default shall be:\n      ")]
          ),
          _vm._m(16),
          _c(
            "div",
            { staticStyle: { "font-weight": "bold", "margin-top": "30px" } },
            [_vm._v("14. NO WAIVER")]
          ),
          _c("div", { staticStyle: { "margin-bottom": "18px" } }, [
            _vm._v(
              "\n        No indulgence, which any Party may grant to the other Party, shall\n        constitute a waiver of any of the Duties or Obligations of the\n        grantor.\n      "
            ),
          ]),
          _c(
            "div",
            { staticStyle: { "font-weight": "bold", "margin-top": "30px" } },
            [_vm._v("15. FORCE MAJEURE")]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "18px", "margin-left": "22px" } },
            [
              _vm._v(
                '\n        15.1 If the performance of this Agreement or any obligation under this\n        Agreement is prevented, restricted, or interfered with by causes\n        beyond either Party\'s reasonable control ("Force Majeure"), and if a\n        Party is unable to carry out its obligations and give the other Party\n        prompt written notice of such an event through the Grupa.io platform,\n        then the obligations of the Party invoking this provision shall be\n        suspended to the extent necessary by such an event.\n      '
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "18px", "margin-left": "22px" } },
            [
              _vm._v(
                "\n        15.2 The term Force Majeure shall include, without limitation, acts of\n        God, fire, explosion, vandalism, storm or other similar occurrence,\n        orders or acts of military or civil authority or by national\n        emergencies, insurrections, riots, or wars, or strikes, lock-outs,\n        work stoppages, or other labor disputes. The excused party shall use\n        reasonable efforts under the circumstances to avoid or remove such\n        causes of non-performance and shall proceed to perform with reasonable\n        dispatch whenever such causes are removed or ceased. An act or\n        omission shall be deemed within the reasonable control of a party if\n        committed, omitted, or caused by such party, or its employees,\n        officers, agents, or affiliates.\n      "
              ),
            ]
          ),
          _c("div", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v("16. ENTIRE AGREEMENT"),
          ]),
          _c("div", { staticStyle: { "margin-bottom": "18px" } }, [
            _vm._v(
              "\n        This Agreement contains the entire agreement of the Parties and there\n        are no other promises or conditions in any other agreement whether\n        oral or written concerning the subject matter of this Agreement, other\n        than such as been consented and agreed upon the Grupa.io platform.\n        Notwithstanding, this Agreement supersedes any prior written or oral\n        agreements between the Parties.\n      "
            ),
          ]),
          _c(
            "div",
            { staticStyle: { "font-weight": "bold", "margin-top": "30px" } },
            [_vm._v("17. SEVERABILITY")]
          ),
          _c("div", { staticStyle: { "margin-bottom": "18px" } }, [
            _vm._v(
              "\n        If any provision of this Agreement will be held to be invalid or\n        unenforceable for any reason, the remaining provisions will continue\n        to be valid and enforceable. If a court finds that any provision of\n        this Agreement is invalid or unenforceable, but that by limiting such\n        provision it would become valid and enforceable, then such provision\n        will be deemed to be written, construed and enforced as so limited.\n      "
            ),
          ]),
          _c(
            "div",
            { staticStyle: { "font-weight": "bold", "margin-top": "30px" } },
            [_vm._v("18. AMENDMENT")]
          ),
          _c("div", { staticStyle: { "margin-bottom": "18px" } }, [
            _vm._v(
              "\n        This Contract may be modified or amended in writing by mutual\n        agreement between the Parties on the Grupa.io platform if the writing\n        is consented to by the party obligated under the amendment and\n        approved on the Grupa.io platform.\n      "
            ),
          ]),
          _c(
            "div",
            { staticStyle: { "font-weight": "bold", "margin-top": "30px" } },
            [_vm._v("19. GOVERNING LAW")]
          ),
          _c("div", { staticStyle: { "margin-bottom": "18px" } }, [
            _vm._v(
              "\n        This Agreement and the interpretation of its terms shall be governed\n        by and construed in accordance with the laws of the state of Delaware\n        and subject to the exclusive jurisdiction of the courts located in\n        Delaware, USA.\n      "
            ),
          ]),
          _c(
            "div",
            { staticStyle: { "font-weight": "bold", "margin-top": "30px" } },
            [_vm._v("\n        20. DISPUTE RESOLUTION\n      ")]
          ),
          _c("div", { staticStyle: { "margin-bottom": "18px" } }, [
            _vm._v(
              "\n        The Parties shall endeavor to settle amicably any dispute, controversy\n        or claim arising whether directly or indirectly from this Agreement by\n        raising support tickets on the Grupa.io platform. If the dispute,\n        difference, or claim is not settled amicably within 60 days of raising\n        a support ticket or escalating such matter to Grupa, the Agreement\n        shall terminate and the Parties shall be referred to mediation or the\n        Courts of Chancery, Delaware.\n      "
            ),
          ]),
          _c(
            "div",
            { staticStyle: { "font-weight": "bold", "margin-top": "30px" } },
            [_vm._v("\n        21. ANTI-BRIBERY & CORRUPTION LAWS\n      ")]
          ),
          _c("div", { staticStyle: { "margin-left": "15px" } }, [
            _vm._v(
              "\n        21.1 The Parties confirm that they have not and no one working on\n        their behalf, including any employee, agent, or consultant, has\n        requested, received or been offered, made or promised any incentive to\n        any person with the intent to influence or induce such a person to do\n        or cease from carrying out an act or to cause such person to grant any\n        advantage whatsoever in connection with the agreement between the\n        Parties.\n      "
            ),
          ]),
          _c(
            "div",
            { staticStyle: { "margin-left": "15px", "margin-bottom": "8px" } },
            [
              _vm._v(
                "\n        21.2 The Parties further confirm that if they or anyone working for or\n        on their behalf should learn of information regarding any such payment\n        or offer, or any other violation of the Anti-Corruption Laws, in\n        connection with any businesses or contracts between Parties, they will\n        immediately advise Grupa of his or her knowledge or suspicion by\n        emailing founders@grupa.io .\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-left": "15px", "margin-bottom": "8px" } },
            [
              _vm._v(
                "\n        21.3 A breach of the provisions of this clause by either Party will be\n        grounds for the termination of this Agreement.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "font-weight": "bold", "margin-top": "30px" } },
            [_vm._v("\n        22. INDEMNIFICATION\n      ")]
          ),
          _c(
            "div",
            { staticStyle: { "margin-left": "15px", "margin-bottom": "8px" } },
            [
              _vm._v(
                "\n        22.1 The Consultant hereby indemnifies and holds harmless the Customer\n        and Grupa from any and all claims, demands, suits, actions,\n        proceedings, loss, cost, interest, award penalties, fines, damages, or\n        expenses of any kind and description, including attorneys’ fees and/or\n        litigation expenses, any claim of a third party, arising out of or\n        occurring in connection with the Consultant’s negligence, willful\n        misconduct, or breach of this Agreement.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-left": "15px", "margin-bottom": "8px" } },
            [
              _vm._v(
                "\n        22.2 The Customer hereby indemnifies and holds harmless Consultant and\n        Grupa from any and all claims, demands, suits, actions, proceedings,\n        loss, cost, interest, award penalties, fines, damages, or expenses of\n        any kind and description, including attorneys’ fees and/or litigation\n        expenses, any claim of a third party, arising out of or occurring in\n        connection with the Customer’s negligence, willful misconduct, or\n        breach of this Agreement.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "font-weight": "bold", "margin-top": "30px" } },
            [_vm._v("\n        23. INDEPENDENT CONTRACTOR\n      ")]
          ),
          _c(
            "div",
            { staticStyle: { "margin-left": "15px", "margin-bottom": "18px" } },
            [
              _vm._v(
                "\n        23.1 The Consultant is an independent private contractor, and neither\n        Consultant nor its employees, agents, or other representatives shall\n        be considered employees or agents of the Client or of Grupa.io or any\n        of its affiliates.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-left": "15px", "margin-bottom": "18px" } },
            [
              _vm._v(
                "\n        23.2 It is understood and agreed by the parties that nothing contained\n        in this Agreement shall be construed to create a joint venture,\n        partnership, association, or other affiliation or relationship between\n        the Parties, it being specifically agreed that their relationship is\n        and shall remain that of independent parties to a contractual\n        relationship as set forth in this Agreement.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-left": "15px", "margin-bottom": "30px" } },
            [
              _vm._v(
                "\n        23.3 The Consultant agrees to perform and discharge all obligations as\n        an independent contractor under any and all laws, whether existing or\n        in the future, in any way pertaining to the engagement of Product\n        under this Agreement.\n      "
              ),
            ]
          ),
          _c("div", { staticStyle: { "margin-bottom": "18px" } }, [
            _vm._v(
              "\n        By accepting this Agreement, each Party agrees and understand that you\n        have read and understood this Agreement and undertake to comply and do\n        all that is written in it.\n      "
            ),
          ]),
          _c(
            "div",
            {
              staticStyle: {
                "font-weight": "bold",
                "margin-bottom": "18px",
                "margin-top": "30px",
              },
            },
            [
              _vm._v(
                "\n        SIGNATURE FOR THE CONSULTANT {EXPERT(s)}\n      "
              ),
            ]
          ),
          _c(
            "table",
            {
              staticStyle: {
                width: "100%",
                border: "1px solid black",
                "margin-top": "32px",
                "margin-bottom": "20px",
              },
            },
            [
              _vm._m(17),
              _vm._l(_vm.teamDetails.members, function (engr) {
                return _c(
                  "tr",
                  {
                    staticStyle: { border: "1px solid #ccc", padding: "10px" },
                  },
                  [
                    _c(
                      "td",
                      {
                        staticStyle: {
                          padding: "10px",
                          "background-color": "#fff",
                          width: "30%",
                          border: "1px solid #ccc",
                        },
                      },
                      [
                        _vm._v(
                          "\n            " + _vm._s(engr.name) + "\n          "
                        ),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticStyle: {
                          padding: "10px",
                          "background-color": "#fff",
                          width: "30%",
                          border: "1px solid #ccc",
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(engr.address) +
                            "\n          "
                        ),
                      ]
                    ),
                    _c("td", {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        width: "30%",
                        border: "1px solid #ccc",
                      },
                    }),
                  ]
                )
              }),
            ],
            2
          ),
          _c(
            "table",
            {
              staticStyle: {
                width: "100%",
                border: "1px solid #ccc",
                "margin-top": "30px",
                "margin-bottom": "20px",
              },
            },
            [
              _vm._m(18),
              _c(
                "tr",
                { staticStyle: { border: "0px solid #ccc", padding: "10px" } },
                [
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "background-color": "#fff",
                        width: "50%",
                        border: "0px solid #ccc",
                        "vertical-align": "top",
                      },
                    },
                    [
                      _vm._v(
                        "\n            NAME: " +
                          _vm._s(_vm.clientName) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._m(19),
                ]
              ),
              _c(
                "tr",
                { staticStyle: { border: "0px solid #ccc", padding: "10px" } },
                [
                  _c(
                    "td",
                    {
                      staticStyle: { padding: "10px", "vertical-align": "top" },
                    },
                    [
                      _vm._v(
                        "\n            ADDRESS: " +
                          _vm._s(_vm.project.organization_address) +
                          "\n          "
                      ),
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "border-left": "1px solid #ccc",
                      },
                    },
                    [
                      _vm._v(
                        "\n            ADDRESS: 4320 STEVENS CREEK BLVD, SAN JOSE\n          "
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "tr",
                { staticStyle: { border: "0px solid #ccc", padding: "10px" } },
                [
                  _c(
                    "td",
                    {
                      staticStyle: { padding: "10px", "vertical-align": "top" },
                    },
                    [
                      _vm._v(
                        "\n            DATE: " +
                          _vm._s(new Date().toDateString()) +
                          "\n          "
                      ),
                    ]
                  ),
                  _c(
                    "td",
                    {
                      staticStyle: {
                        padding: "10px",
                        "border-left": "1px solid #ccc",
                        "padding-bottom": "50px",
                        "vertical-align": "top",
                      },
                    },
                    [
                      _vm._v(
                        "\n            DATE: " +
                          _vm._s(new Date().toDateString()) +
                          "\n          "
                      ),
                    ]
                  ),
                ]
              ),
              _vm._m(20),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "font-weight": "bold", "margin-top": "40px" } },
            [_vm._v("\n        APPENDIX: STATEMENT OF WORK\n      ")]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "8px", "margin-left": "20px" } },
            [
              _vm._v(
                "\n        a. PRODUCT ROADMAP: We hereby adopt as reference the outline of the\n        product roadmap developed on the Grupa platform as the statement of\n        work (i.e the Service to be done) as agreed by both parties.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "8px", "margin-left": "20px" } },
            [
              _vm._v(
                "\n        b. Product Management: To manage the development of the Sympler V1\n        platform\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "8px", "margin-left": "20px" } },
            [
              _vm._v(
                "\n        c. Execution Management Tracking System: To guarantee delivery and\n        compliance of both parties, the Customer and the Consultant commit to\n        tracking and managing the product execution and statement of work on\n        the Grupa platform.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "font-weight": "bold", "margin-top": "40px" } },
            [
              _vm._v(
                "\n        APPENDIX B: ASSIGNMENT OF INTELLECTUAL PROPERTY\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "10px", "margin-left": "20px" } },
            [
              _vm._v(
                "\n        Subject to receipt of full payment from Customer for work done,\n        Customer shall own, and Consultant hereby irrevocably transfers to\n        Customer, all rights, titles, and interests in and to all Services\n        created by Consultant for Customer, as set forth in the applicable\n        Statement of Work, and any intellectual property rights connected\n        therewith, including, but not limited to all ideas, inventions,\n        discoveries, know-how, computer programs, improvements, methods,\n        developments, and other creative works and works of authorship,\n        whether or not patentable or copyrightable, conceived or made or\n        reduced to practice (whether solely or with the participation of\n        others) by Consultant. Consultant shall not retain the right to reuse\n        or incorporate, without the written consent of Customer, its\n        technology, Pre-existing works, work product, and intellectual\n        property provided in the Services or the development of the Services.\n        If any Services falls within the definition of “work made for hire” in\n        the U. S. Copyright Act, 17 U.S.C. §101 et seq., then for purposes of\n        this Agreement such Services shall be deemed to be a “work made for\n        hire,” the copyright of which shall be owned solely and exclusively by\n        Customer. If Consultant would be deemed to retain by operation of law\n        or otherwise any intellectual property rights in any such Services,\n        then Consultant hereby assigns and transfers all such retained\n        intellectual property rights to Customer and its successors. where the\n        Consultant has retained any rights in the Services for themselves, or\n        in the event that the Consultant is not available to execute any such\n        documents to this effect, when required, the Consultant irrevocably\n        appoints the Company as its attorney-in-fact to execute all such\n        documents on its behalf.\n      "
              ),
            ]
          ),
          _c(
            "div",
            { staticStyle: { "margin-bottom": "8px", "margin-left": "20px" } },
            [
              _vm._v(
                "\n        As used in this Agreement, the term “Pre-Existing Works” shall mean\n        all the Applications developed by the Customer or its associates,\n        copyrights, patents, trade secrets, or other intellectual property\n        rights owned by or licensed by the Customer prior to the date of this\n        Agreement. Ownership of the Pre-Existing Works and work products shall\n        remain with the Customer. Without Customer’s prior written permission,\n        Consultant shall not itself, or through any other party use the\n        Services to provide any service, or “service bureau” services to third\n        parties; or remove any copyright notices from any Services.\n      "
              ),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "spandiv", staticStyle: { "margin-bottom": "18px" } },
      [_c("b", [_vm._v("WHEREAS:")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "spandiv", staticStyle: { "margin-bottom": "18px" } },
      [_c("b", [_vm._v("DEFINITIONS & INTERPRETATIONS")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-bottom": "18px" } }, [
      _c("span", { staticStyle: { "font-weight": "bold" } }, [
        _vm._v('"Agreement"'),
      ]),
      _c("span", [
        _vm._v(
          "\n          shall mean this agreement, any schedule and appendix attached\n          thereto as well as addendum executed pursuant to this\n          Agreement"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-bottom": "18px" } }, [
      _c("span", { staticStyle: { "font-weight": "bold" } }, [
        _vm._v('"Grupa.io"'),
      ]),
      _c("span", [
        _vm._v(
          "\n          shall mean the web-based technology platform that connects product\n          teams to business owners and through which the Client has initially\n          engaged the services of the Consultant;"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-bottom": "18px" } }, [
      _c("span", { staticStyle: { "font-weight": "bold" } }, [
        _vm._v('"Services"'),
      ]),
      _c("span", [
        _vm._v(
          "\n          shall mean the Development of Digital Solutions for the Client as\n          more particularly described in the Statement of Work attached to\n          this Agreement and provided via the Grupa.io platform."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-bottom": "18px" } }, [
      _c("span", { staticStyle: { "font-weight": "bold" } }, [
        _vm._v('"Statement of Work"'),
      ]),
      _c("span", {}, [
        _vm._v(
          "shall mean the statement of work, the scope of work, and product\n          roadmap agreed between the Parties to form the core of the Services\n          to be provided by the Consultant to the Client and detailed in the\n          appendix to this Agreement."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-bottom": "18px" } }, [
      _c("span", { staticStyle: { "font-weight": "bold" } }, [
        _vm._v("NOW,THEREFORE,"),
      ]),
      _c("span", {}, [
        _vm._v(
          'in consideration of the earlier discussions between the Client and\n          Consultant, regarding design thinking, product strategy and\n          development of product workflow to create iterations of a product,\n          and the mutual covenants and promises made by the Parties to this\n          Service Level Agreement, the Company and the Client (individually,\n          each a "Party" and collectively, the "Parties") covenant and agree\n          as follows'
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "table",
      {
        staticStyle: {
          width: "100%",
          border: "1px solid black",
          "margin-top": "10px",
          "margin-bottom": "20px",
        },
      },
      [
        _c(
          "tr",
          { staticStyle: { border: "1px solid #ccc", padding: "10px" } },
          [
            _c(
              "td",
              {
                staticStyle: { padding: "10px", "background-color": "#eee" },
                attrs: { colspan: "2" },
              },
              [
                _vm._v(
                  "\n            SECTION A: Engagement Expectations\n          "
                ),
              ]
            ),
          ]
        ),
        _c(
          "tr",
          { staticStyle: { border: "1px solid #ccc", padding: "10px" } },
          [
            _c(
              "td",
              {
                staticStyle: {
                  padding: "10px",
                  "background-color": "#fff",
                  width: "30%",
                  border: "1px solid #ccc",
                },
              },
              [_vm._v("\n            Services\n          ")]
            ),
            _c(
              "td",
              {
                staticStyle: {
                  padding: "10px",
                  "background-color": "#fff",
                  border: "1px solid #ccc",
                },
              },
              [
                _vm._v(
                  "\n            Tech development & consulting\n          "
                ),
              ]
            ),
          ]
        ),
        _c(
          "tr",
          { staticStyle: { border: "1px solid #ccc", padding: "10px" } },
          [
            _c(
              "td",
              {
                staticStyle: {
                  padding: "10px",
                  "background-color": "#fff",
                  width: "20%",
                  border: "1px solid #ccc",
                },
              },
              [_vm._v("\n            Service Capacity\n          ")]
            ),
            _c("td", {
              staticStyle: {
                padding: "10px",
                "background-color": "#fff",
                border: "1px solid #ccc",
              },
            }),
          ]
        ),
        _c(
          "tr",
          { staticStyle: { border: "1px solid #ccc", padding: "10px" } },
          [
            _c(
              "td",
              {
                staticStyle: {
                  padding: "10px",
                  "background-color": "#fff",
                  width: "20%",
                  border: "1px solid #ccc",
                },
              },
              [_vm._v("\n            Initial Term\n          ")]
            ),
            _c("td", {
              staticStyle: {
                padding: "10px",
                "background-color": "#fff",
                border: "1px solid #ccc",
              },
            }),
          ]
        ),
        _c(
          "tr",
          { staticStyle: { border: "1px solid #ccc", padding: "10px" } },
          [
            _c(
              "td",
              {
                staticStyle: {
                  padding: "10px",
                  "background-color": "#fff",
                  width: "20%",
                  border: "1px solid #ccc",
                },
              },
              [_vm._v("\n            Name of the Product\n          ")]
            ),
            _c("td", {
              staticStyle: {
                padding: "10px",
                "background-color": "#fff",
                border: "1px solid #ccc",
              },
            }),
          ]
        ),
        _c(
          "tr",
          { staticStyle: { border: "1px solid #ccc", padding: "10px" } },
          [
            _c(
              "td",
              {
                staticStyle: {
                  padding: "10px",
                  "background-color": "#fff",
                  width: "20%",
                  border: "1px solid #ccc",
                },
              },
              [_vm._v("\n            Brief Description of Product\n          ")]
            ),
            _c("td", {
              staticStyle: {
                padding: "10px",
                "background-color": "#fff",
                border: "1px solid #ccc",
              },
            }),
          ]
        ),
        _c(
          "tr",
          { staticStyle: { border: "1px solid #ccc", padding: "10px" } },
          [
            _c(
              "td",
              {
                staticStyle: {
                  padding: "10px",
                  "background-color": "#fff",
                  width: "20%",
                  border: "1px solid #ccc",
                },
              },
              [_vm._v("\n            Key Goals\n          ")]
            ),
            _c("td", {
              staticStyle: {
                padding: "10px",
                "background-color": "#fff",
                border: "1px solid #ccc",
              },
            }),
          ]
        ),
        _c(
          "tr",
          { staticStyle: { border: "1px solid #ccc", padding: "10px" } },
          [
            _c(
              "td",
              {
                staticStyle: {
                  padding: "10px",
                  "background-color": "#fff",
                  width: "20%",
                  border: "1px solid #ccc",
                },
              },
              [_vm._v("\n            Reservation Fee\n          ")]
            ),
            _c(
              "td",
              {
                staticStyle: {
                  padding: "10px",
                  "background-color": "#fff",
                  border: "1px solid #ccc",
                },
              },
              [
                _vm._v(
                  "\n            $500 for booking fees. For an initial consultation, evaluation,\n            ideation, and execution planning.\n          "
                ),
              ]
            ),
          ]
        ),
        _c(
          "tr",
          { staticStyle: { border: "1px solid #ccc", padding: "10px" } },
          [
            _c(
              "td",
              {
                staticStyle: {
                  padding: "10px",
                  "background-color": "#fff",
                  width: "20%",
                  border: "1px solid #ccc",
                },
              },
              [_vm._v("\n            Grupa SaaS Fee\n          ")]
            ),
            _c(
              "td",
              {
                staticStyle: {
                  padding: "10px",
                  "background-color": "#fff",
                  border: "1px solid #ccc",
                },
              },
              [
                _vm._v(
                  "\n            $0 (Grupa platform is free to use until June 2023)\n          "
                ),
              ]
            ),
          ]
        ),
        _c(
          "tr",
          { staticStyle: { border: "1px solid #ccc", padding: "10px" } },
          [
            _c(
              "td",
              {
                staticStyle: {
                  padding: "10px",
                  "background-color": "#fff",
                  width: "20%",
                  border: "1px solid #ccc",
                },
              },
              [_vm._v("\n            Services\n          ")]
            ),
            _c(
              "td",
              {
                staticStyle: {
                  padding: "10px",
                  "background-color": "#fff",
                  border: "1px solid #ccc",
                },
              },
              [
                _vm._v(
                  "\n            Company will use commercially reasonable efforts to provide the\n            Customer with the services described in the Statement of Work\n            (“SOW”) attached as Exhibit A hereto (“Services”), and the\n            Customer shall pay Company the Implementation Fee in accordance\n            with the terms herein.\n          "
                ),
              ]
            ),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "tr",
      { staticStyle: { border: "1px solid #ccc", padding: "10px" } },
      [
        _c(
          "td",
          {
            staticStyle: {
              padding: "10px",
              "background-color": "#fff",
              width: "20%",
              border: "1px solid #ccc",
            },
          },
          [_vm._v("\n            Startup Stage\n          ")]
        ),
        _c("td", {
          staticStyle: {
            padding: "10px",
            "background-color": "#fff",
            width: "20%",
            border: "1px solid #ccc",
          },
        }),
        _c(
          "td",
          {
            staticStyle: {
              padding: "10px",
              "background-color": "#fff",
              border: "1px solid #ccc",
            },
          },
          [
            _vm._v(
              "\n            Part-time Commitment [15-20hrs per week]\n          "
            ),
          ]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "tr",
      { staticStyle: { border: "1px solid #ccc", padding: "10px" } },
      [
        _c(
          "td",
          {
            staticStyle: { padding: "10px", "background-color": "#eee" },
            attrs: { colspan: "6" },
          },
          [_vm._v("\n            Experts\n          ")]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "tr",
      { staticStyle: { border: "1px solid #ccc", padding: "10px" } },
      [
        _c("td", {
          staticStyle: {
            padding: "10px",
            "background-color": "#fff",
            width: "20%",
            border: "1px solid #ccc",
          },
        }),
        _c("td", {
          staticStyle: {
            padding: "10px",
            "background-color": "#fff",
            width: "20%",
            border: "1px solid #ccc",
          },
        }),
        _c(
          "th",
          {
            staticStyle: {
              padding: "10px",
              "background-color": "#fff",
              border: "1px solid #ccc",
            },
          },
          [_vm._v("\n            Hours/Week\n          ")]
        ),
        _c(
          "th",
          {
            staticStyle: {
              padding: "10px",
              "background-color": "#fff",
              width: "20%",
              border: "1px solid #ccc",
            },
          },
          [_vm._v("\n            Cash/Month\n          ")]
        ),
        _c(
          "th",
          {
            staticStyle: {
              padding: "10px",
              width: "20%",
              "background-color": "#fff",
              border: "1px solid #ccc",
            },
          },
          [_vm._v("\n            Equity\n          ")]
        ),
        _c(
          "th",
          {
            staticStyle: {
              padding: "10px",
              width: "20%",
              "background-color": "#fff",
              border: "1px solid #ccc",
            },
          },
          [_vm._v("\n            Subtotal\n          ")]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", {
        staticStyle: {
          padding: "10px",
          "background-color": "#fff",
          width: "20%",
        },
      }),
      _c("td", { staticStyle: { padding: "10px", width: "20%" } }),
      _c("td", {
        staticStyle: {
          padding: "10px",
          width: "20%",
          "background-color": "#fff",
        },
      }),
      _c(
        "td",
        {
          staticStyle: {
            padding: "10px",
            width: "20%",
            "padding-left": "20p",
            "text-align": "right",
          },
        },
        [_vm._v("\n            Discount\n          ")]
      ),
      _c("td", { staticStyle: { padding: "10px", width: "20%" } }),
      _c(
        "th",
        { staticStyle: { padding: "10px", "background-color": "#fff" } },
        [_vm._v("$0.00")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", {
        staticStyle: {
          padding: "10px",
          "background-color": "#fff",
          width: "20%",
        },
      }),
      _c("td", { staticStyle: { padding: "10px", width: "20%" } }),
      _c("td", {
        staticStyle: {
          padding: "10px",
          width: "20%",
          "background-color": "#fff",
        },
      }),
      _c(
        "td",
        {
          staticStyle: {
            padding: "10px",
            width: "20%",
            "padding-left": "20px",
            "text-align": "right",
          },
        },
        [_vm._v("\n            Tax\n          ")]
      ),
      _c("td", { staticStyle: { padding: "10px", width: "20%" } }),
      _c(
        "th",
        { staticStyle: { padding: "10px", "background-color": "#fff" } },
        [_vm._v("$562.50")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "tr",
      { staticStyle: { border: "1px solid #ccc", padding: "10px" } },
      [
        _c(
          "td",
          {
            staticStyle: {
              padding: "10px",
              "background-color": "#fff",
              border: "1px solid #ccc",
            },
          },
          [_vm._v("\n            ITERATION\n          ")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              padding: "10px",
              "background-color": "#fff",
              border: "1px solid #ccc",
            },
          },
          [_vm._v("\n            WEEKLY SPRINT\n          ")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              padding: "10px",
              "background-color": "#fff",
              border: "1px solid #ccc",
            },
          },
          [_vm._v("\n            STARTUP PAYS PER EXPERT\n          ")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              padding: "10px",
              "background-color": "#fff",
              border: "1px solid #ccc",
            },
          },
          [_vm._v("\n            GRUPA TAKE RATE (IN %)\n          ")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              padding: "10px",
              "background-color": "#fff",
              border: "1px solid #ccc",
            },
          },
          [_vm._v("\n            EXPERT TAKEHOME\n          ")]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { "margin-bottom": "18px", "margin-left": "20px" } },
      [
        _vm._v(
          "\n        The Consultant undertakes not to disclose to any third party the\n        nature of work of the Customer, including the business of the\n        Customer, details regarding the Product and Statement of Work,\n        including, without limitation any information regarding the Product’s\n        code, the specifications, the Work Product or the Customer’s customers\n        (the “Confidential Information”), (ii) make copies of any Confidential\n        Information or any content based on the concepts contained within the\n        Confidential Information for personal use or for distribution unless\n        so permitted by the Customer, or (iii) use Confidential Information\n        other than solely for the benefit of the Customer.\n        "
        ),
        _c("br"),
        _c("br"),
        _vm._v(
          "\n\n        “Confidential Information” means all information or data disclosed\n        (whether in writing, orally or by any other means) to one party by the\n        other party or by a third party on behalf of the other party and shall\n        include but not be limited to;\n      "
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-bottom": "18px" } }, [
      _c(
        "div",
        { staticStyle: { "margin-bottom": "8px", "margin-left": "20px" } },
        [
          _vm._v(
            "\n          (a) Information relating to the organizational structure, marketing\n          strategy, and product roadmap of the Parties and any other\n          information relating to the business operations, processes, plans,\n          intentions, product information, know-how, design rights, trade\n          secrets, software, market opportunities, customers and affairs of\n          the Parties;\n        "
          ),
        ]
      ),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "8px", "margin-left": "20px" } },
        [
          _vm._v(
            "\n          (b) Technical information to any products or services supplied by\n          the Parties;\n        "
          ),
        ]
      ),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "8px", "margin-left": "20px" } },
        [
          _vm._v(
            "\n          (c) Information relating to the officers, directors, or employees of\n          the Parties including their terms and conditions of employment or\n          engagement;\n        "
          ),
        ]
      ),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "8px", "margin-left": "20px" } },
        [
          _vm._v(
            "\n          (d) The information which is disclosed orally and identified as\n          confidential at the time of disclosure;\n        "
          ),
        ]
      ),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "8px", "margin-left": "20px" } },
        [
          _vm._v(
            "\n          (e) The existence and content of this Agreement and matters\n          incidental thereto;\n        "
          ),
        ]
      ),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "8px", "margin-left": "20px" } },
        [
          _vm._v(
            "\n          (f) Any information ascertainable by the inspection of accounts, and\n          other records;\n        "
          ),
        ]
      ),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "8px", "margin-left": "20px" } },
        [
          _vm._v(
            "\n          (g) Financial, legal, and any other information provided in due\n          diligence checklists to be provided after execution hereof;\n        "
          ),
        ]
      ),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "8px", "margin-left": "20px" } },
        [
          _vm._v(
            "\n          (h) Any information relating to that Party’s business, operations,\n          plans, intentions, market opportunities, customers, and business\n          affairs; and\n        "
          ),
        ]
      ),
      _c(
        "div",
        { staticStyle: { "margin-bottom": "28px", "margin-left": "20px" } },
        [_vm._v("\n          (i) Any Intellectual Property.\n        ")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticStyle: { "margin-left": "42px", "margin-bottom": "18px" } },
      [
        _c("div", { staticStyle: { "margin-left": "15px" } }, [
          _vm._v(
            "\n          13.3.1 Non-payment of Consideration by Customer as at and when due;\n        "
          ),
        ]),
        _c("div", { staticStyle: { "margin-left": "15px" } }, [
          _vm._v(
            "\n          13.3.2 Failure by the Client to deliver such information or\n          materials required for the Product;\n        "
          ),
        ]),
        _c("div", { staticStyle: { "margin-left": "15px" } }, [
          _vm._v(
            "\n          13.3.3 Consultant's failure to perform the Product as contained in\n          the Statement of Work;\n        "
          ),
        ]),
        _c("div", { staticStyle: { "margin-left": "15px" } }, [
          _vm._v(
            "\n          13.3.4 Either Party not fulfilling its Duties or Obligations as\n          stated in this Agreement.\n        "
          ),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "tr",
      { staticStyle: { border: "1px solid #ccc", padding: "10px" } },
      [
        _c(
          "td",
          {
            staticStyle: {
              padding: "10px",
              "background-color": "#fff",
              width: "30%",
            },
          },
          [_vm._v("\n            Name\n          ")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              padding: "10px",
              "background-color": "#fff",
              border: "1px solid #ccc",
            },
          },
          [_vm._v("\n            Address\n          ")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              padding: "10px",
              "background-color": "#fff",
              border: "1px solid #ccc",
              width: "30%",
            },
          },
          [_vm._v("\n            Date & Sign\n          ")]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "tr",
      { staticStyle: { border: "1px solid #ccc", padding: "10px" } },
      [
        _c(
          "th",
          {
            staticStyle: {
              padding: "10px",
              "background-color": "#fff",
              width: "50%",
              border: "1px solid #ccc",
            },
          },
          [_vm._v("\n            THE CUSTOMER\n          ")]
        ),
        _c(
          "th",
          {
            staticStyle: {
              padding: "10px",
              "background-color": "#fff",
              border: "1px solid #ccc",
              width: "50%",
            },
          },
          [_vm._v("\n            GRUPA\n          ")]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "td",
      {
        staticStyle: {
          padding: "10px",
          "background-color": "#fff",
          "border-left": "1px solid #ccc",
          width: "50%",
          "vertical-align": "top",
        },
      },
      [
        _vm._v(
          "\n            NAME: Damilola Thompson, Co-founder, COO, Platohub Inc, dba\n            "
        ),
        _c("b", [_vm._v("Grupa")]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "tr",
      { staticStyle: { border: "0px solid #ccc", padding: "10px" } },
      [
        _c(
          "td",
          { staticStyle: { padding: "10px", "vertical-align": "top" } },
          [_vm._v("\n            SIGN:\n          ")]
        ),
        _c(
          "td",
          {
            staticStyle: {
              padding: "10px",
              "border-left": "1px solid #ccc",
              "padding-bottom": "50px",
              "vertical-align": "top",
            },
          },
          [_vm._v("\n            SIGN:\n          ")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }